import styled from "styled-components";
import { TextButton, WhiteContainer } from "../../components";

export const ButtonsPopupStyled = styled(WhiteContainer)`
  border-radius: 4px;
  position: absolute;

  display: ${(props) => (props?.visible ? "flex" : "none")};
  justify-content: flex-start;
  align-items: flex-start;

  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16);
  border: ${(props) => props?.theme?.darkMode && `1px solid rgba(110, 110, 116, 0.55)`};

  gap: 8px;
  padding: 8px 0;

  width: 200px;

  top: 52px;
  margin-left: -92px;

  z-index: 100;

  ${TextButton} {
    display: flex;
    flex-direction: row;
    align-items: center;

    height: 34px;
    width: 100%;

    padding: 0 16px;

    svg {
      margin-right: 13px;
    }

    &:hover {
      opacity: 1;
      background: rgba(52, 48, 61, 0.1);
    }
  }
`;
